import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';

export class ViewStateServiceRecord implements IGenericAccessor {
    protected dataMap: Record<string, any> = {};
    protected keys: Record<string, boolean> = {};
    protected keysToSkip: Record<string, boolean> = {
        CumeTime: true,
        FrontTime: true,
        BackTime: true,
        BackCumeTime: true,
    };

    constructor(data: any) {
        for (const key in data) {
            if (this.keysToSkip[key]) {
                continue;
            }
            this.dataMap[key] = data[key];
            this.keys[key] = true;
        }
    }

    public contains(fieldName: string): boolean {
        return this.keys[fieldName];
    }

    public getAs<T>(fieldName: string): T {
        if (this.keys[fieldName]) {
            return this.dataMap[fieldName];
        }
        return null;
    }

    public get(fieldName: string): any {
        return this.getAs<any>(fieldName);
    }

    public set(fieldName: string, fieldValue: any) {
        this.keys[fieldName] = true;
        this.dataMap[fieldName] = fieldValue;
    }

    public getMetaData(): Record<string, number> {
        const ret = {};
        for (const key in this.dataMap) {
            const knownType = KnownPropertyTypes.for(key);
            if (knownType) {
                ret[key] = knownType;
            } else {
                ret[key] = DataType.guess(this.dataMap[key]);
            }
        }
        return ret;
    }

    public getRawValue(field: string): any {
        return this.get(field);
    }
}
